import { IntegrationStatus } from 'src/constants';
import type { IntegrationActionValues, PlatformIntegrationStatusesTransformed } from 'src/types/platforms';

export const getStagingStatus = (
  data: PlatformIntegrationStatusesTransformed,
  targetActionId: IntegrationActionValues,
) => data.find(({ actionId }) => actionId === targetActionId)?.stagingStatus;

export const getProdStatus = (data: PlatformIntegrationStatusesTransformed, targetActionId: IntegrationActionValues) =>
  data.find(({ actionId }) => actionId === targetActionId)?.prodStatus;

export const getActionsLeft = (data: PlatformIntegrationStatusesTransformed, actionIds: IntegrationActionValues[]) =>
  data.filter(
    ({ actionId, stagingStatus, prodStatus }) =>
      actionIds.includes(actionId) &&
      ((stagingStatus !== IntegrationStatus.DONE && stagingStatus !== IntegrationStatus.NOT_ACTUAL) ||
        prodStatus !== IntegrationStatus.DONE),
  ).length;
